import { type AlgoliaIndexType } from "./types";

export const AlgoliaIndex = ["customers", "users", "entities", "assets", "invoices", "routes"] as const;
export const CloudAnalyticsIndex = ["allocations", "reports", "budgets", "alerts", "metrics"] as const;
export const CloudflowSearchIndex = ["cloudflow_aws_api", "cloudflow_gcp_api", "cloudflow_doit_api"] as const;

export const AlgoliaListSubHeaders: { [key in AlgoliaIndexType]: string } = {
  customers: "Customers",
  users: "Users",
  entities: "Billing profiles",
  assets: "Assets",
  invoices: "Invoices",
  allocations: "Allocations",
  alerts: "Alerts",
  budgets: "Budgets",
  metrics: "Metrics",
  reports: "Reports",
  routes: "Quick links",
  cloudflow_aws_api: "AWS",
  cloudflow_gcp_api: "Google Cloud",
  cloudflow_doit_api: "DoiT Console",
};
